var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCalendar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.078431 0 0 0 0 0.262745 0 0 0 0 0.658824 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    filter: "url(#prefix__a)",
    transform: "translate(1 -9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#A7B9DB",
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "M4 11H6V12H4zM10 11H12V12H10zM4 16H6V17H4zM10 16H12V17H10zM16 11H18V12H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7B9DB",
    fillRule: "nonzero",
    d: "M4 11H6V12H4zM10 11H12V12H10zM4 16H6V17H4zM10 16H12V17H10zM16 11H18V12H16z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 19,
    y: 2,
    stroke: "#A7B9DB",
    strokeLinecap: "square",
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A7B9DB",
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "M5 0L5 3M17 0L17 3M0 7L22 7"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar.a3430c01.svg";
export { ForwardRef as ReactComponent };